<template>
  <form autocomplete="false" v-on:submit.prevent>
    <vue-form-generator :schema="schema" :model="datas" :options="formOptions"></vue-form-generator>
  </form>
</template>

<script>
import { getReparationTypes, addReparationTypes, updateReparationTypes, deleteReparationTypes } from '@/api/crm-api.js'

export default {
  props: {
    id: String
  },
  data () {
    return {
      datas: {},
      schema: {
        groups: [
          {
            legend: 'Types',
            fields: [
              {
                type: 'input',
                inputType: 'text',
                label: 'Name',
                model: 'name',
                placeholder: 'Name'
              },
              {
                type: 'input',
                inputType: 'text',
                label: 'Picture',
                model: 'picture',
                placeholder: 'Picture'
              },
              {
                type: 'input',
                inputType: 'text',
                label: 'Rank',
                model: 'rank',
                placeholder: 'Rank'
              }
            ]
          },
          {
            legend: '',
            fields: [
              {
                type: 'submit',
                buttonText: 'Ajouter',
                onSubmit: this.add,
                styleClasses:'col-auto p-0 float-right',
                validateBeforeSubmit: true,
                visible (status) {
                    return status != null && status.id == null;
                }
              },
              {
                type: 'submit',
                buttonText: 'Sauver',
                validateBeforeSubmit: true,
                onSubmit: this.update,
                styleClasses:'col-auto p-0 float-right',
                visible (status) {
                    return status != null && status.id != null;
                }
              },
              {
                type: 'submit',
                buttonText: 'Supprimer',
                validateBeforeSubmit: false,
                onSubmit: this.delete,
                styleClasses:'col-auto float-left p-0',
                visible (status) {
                    return status != null && status.id != null;
                }
              }
            ]
          }
        ]
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true
      }
    }
  },
  methods: {
    add () {
      addReparationTypes(this.datas).then((response) => {
        this.$router.push({name:'reparationTypeManager', params:{ id: response.data.id }}).catch(() => {})
        this.$store.commit('addMessage',{text:'Le type ' + this.datas.name + ' à été crée', status:'success'})
      })
      .catch((error) => {
        this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
      })
    },
    update () {
      updateReparationTypes(this.id,this.datas).then(() => {
        this.$store.commit('addMessage',{text:'Le type ' + this.datas.name + ' à été mis à jour', status:'success'})
        this.$emit('onUpdate')
      })
      .catch((error) => {
        this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
      })
    },
    delete () {
      if (confirm('Etes vous sur de vouloir supprimer le type ' + this.datas.name)){
        deleteReparationTypes(this.id).then(() => {
          this.$emit('onDelete')
          this.$store.commit('addMessage',{text:'Le type à été supprimé', status:'success'})
        })
        .catch((error) => {
          this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
        })
      }
    }
  },
  watch: {
    id: {
      immediate: true,
      handler: function () {
        if(this.id != null) {
          getReparationTypes(this.id)
          .then((response) => {
            this.datas = response.data
          })
          .catch((error) => {
            this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
          })
        } else {
          this.datas = {}
        }
      }
    }
  },
}
</script>

<style>

</style>
